import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PanelCards } from '../../../Panel';
import SoilSsurgoCard from '../../../../components/cards/soilSsurgo/SoilSsurgoCard';
import SoilSsurgoPreview from '../../../../components/cards/soilSsurgo/SoilSsurgoPreview';
import { setActiveSubLayer } from '../../../../actions/layersActions';
import { soilSsurgoZonesSelector } from '../../../../selectors/mosaicSelectors';
import { FHA, HARVEST, PLANTING, WEATHER } from '../../../../constants/cards';
import { BASE_LAYERS } from '../../../../constants/mapLayerIds';
import { SEASON_AGNOSTIC } from '../../../../constants/seasonIds';

const LAYER = BASE_LAYERS.SOIL_SSURGO;
const CARDS = [WEATHER, PLANTING, HARVEST, FHA];

export class SoilSsurgoPanel extends Component {
  setActiveZoneIndex = (e) => {
    const {
      collapsePanel,
      index,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;
    const newActiveZoneIndex = parseInt(e.currentTarget.id, 10);
    setActiveSubLayerProp(LAYER, newActiveZoneIndex, index);
    collapsePanel();
  };

  decrementZoneIndex = () => {
    const {
      activeZoneIndex,
      setActiveSubLayer: setActiveSubLayerProp,
      index,
      zones,
    } = this.props;
    const newIndex =
      activeZoneIndex === 0 ? zones.length - 1 : activeZoneIndex - 1;
    setActiveSubLayerProp(LAYER, newIndex, index);
  };

  incrementZoneIndex = () => {
    const {
      activeZoneIndex,
      index,
      zones,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;
    const newIndex =
      activeZoneIndex >= zones.length - 1 ? 0 : activeZoneIndex + 1;
    setActiveSubLayerProp(LAYER, newIndex, index);
  };

  render() {
    const {
      activeZoneIndex,
      index,
      isCollapsed,
      isSplitViewEnabled,
      zones,
      activeLayer,
    } = this.props;
    const activeZone = zones && (zones[activeZoneIndex] || null);
    const headerDetail = activeZone && activeZone.area;
    const firstCard =
      isSplitViewEnabled && isCollapsed ? (
        <SoilSsurgoPreview
          activeZone={activeZone}
          decrementZoneIndex={this.decrementZoneIndex}
          incrementZoneIndex={this.incrementZoneIndex}
          isLoading={!zones}
        />
      ) : (
        <SoilSsurgoCard
          activeLayer={activeLayer}
          activeZoneIndex={activeZoneIndex}
          onClick={this.setActiveZoneIndex}
          zones={zones}
        />
      );

    return (
      <PanelCards
        cards={CARDS}
        firstCard={firstCard}
        headerDetail={headerDetail}
        index={index}
        isCollapsed={isCollapsed}
        testId="soil-ssurgo"
      />
    );
  }
}

SoilSsurgoPanel.propTypes = {
  activeLayer: PropTypes.string,
  activeZoneIndex: PropTypes.number.isRequired,
  collapsePanel: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool,
  isSplitViewEnabled: PropTypes.bool.isRequired,
  setActiveSubLayer: PropTypes.func.isRequired,
  zones: PropTypes.array,
};

function mapStateToProps(state, props) {
  return {
    activeZoneIndex:
      state.layers.list[SEASON_AGNOSTIC][LAYER].activeSubLayerIds[props.index],
    zones: soilSsurgoZonesSelector(state),
    activeLayer: state.layers.activeMapLayers[props.index].id,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveSubLayer,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SoilSsurgoPanel);
